import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const BlockCommentKind = withMessage(io.strict({ kind: io.literal("COMMENT") }), () =>
  t("schema.block.kind"),
);

export const BlockCommentData = io.type({ data: io.string });

export const BlockCommentModel = io.intersection([BlockModel, BlockCommentKind, BlockCommentData]);

export const BlockCommentImport = io.intersection([
  BlockImport,
  BlockCommentKind,
  BlockCommentData,
]);

export type BlockCommentModelT = io.TypeOf<typeof BlockCommentModel>;
export type BlockCommentImportT = io.TypeOf<typeof BlockCommentImport>;
